// Keeps a visible "Availability" line item property in sync with the cart backorder badge
// (snippets/cart-backorder-badge.liquid) so the note shows at checkout and on the order.
// Existing properties (including FBP's hidden "_" ones) are merged, never dropped.
(() => {
  const PROPERTY = 'Availability';
  const SECTIONS = 'cart-drawer,cart,cart-bubble';
  const root = () => window.Shopify.routes.root;
  const attempted = new Set();
  let syncing = null;
  let dispatching = false;

  function pendingLines(scope) {
    const lines = new Map();
    scope.querySelectorAll('[data-backorder-sync]').forEach((el) => {
      if (!attempted.has(el.dataset.key)) {
        lines.set(el.dataset.key, { want: el.dataset.want === 'true', note: el.dataset.note });
      }
    });
    return lines;
  }

  async function run(scope) {
    const lines = pendingLines(scope);
    if (!lines.size) return;

    const cart = await fetch(`${root()}cart.js`).then((res) => res.json());
    let changed = false;

    for (const [key, { want, note }] of lines) {
      const item = cart.items.find((i) => i.key === key);
      attempted.add(key);
      if (!item) continue;

      const properties = { ...(item.properties || {}) };
      if (want) {
        properties[PROPERTY] = note;
      } else {
        delete properties[PROPERTY];
      }

      const res = await fetch(`${root()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: item.quantity, properties })
      });
      if (res.ok) changed = true;
    }

    if (!changed) return;

    const sections = await fetch(`${root()}?sections=${SECTIONS}`).then((res) => res.json());
    dispatching = true;
    document.dispatchEvent(new CustomEvent('cart-update', { detail: { sections }, bubbles: true }));
    dispatching = false;
  }

  function sync(scope = document) {
    if (!syncing) {
      syncing = run(scope)
        .catch((err) => console.error('Backorder note sync failed: ', err))
        .finally(() => { syncing = null; });
    }
    return syncing;
  }

  // Re-check against fresh cart markup, since apps (e.g. FBP) can add lines without re-rendering the drawer.
  async function syncFresh() {
    const sections = await fetch(`${root()}?sections=cart-drawer`).then((res) => res.json());
    const scope = document.createElement('div');
    scope.innerHTML = sections['cart-drawer'] || '';
    await sync(scope);
  }

  document.addEventListener('DOMContentLoaded', () => sync());

  // critical.js registers its re-render listener first, so the DOM is already updated here.
  document.addEventListener('cart-update', () => {
    if (!dispatching) sync();
  });

  document.addEventListener('click', async (e) => {
    const link = e.target.closest('a[href$="/checkout"]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;

    e.preventDefault();
    try {
      await syncFresh();
    } catch (err) {
      console.error('Backorder note sync failed: ', err);
    }
    window.location.href = link.href;
  });
})();
